import { Component, type ErrorInfo, type ReactNode } from 'react'
import { AlertTriangle, RotateCcw } from 'lucide-react'

type Props = { children: ReactNode }
type State = { failed: boolean }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { failed: false }

  static getDerivedStateFromError(): State { return { failed: true } }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('LIVROOM UI error', error, info.componentStack)
  }

  render() {
    if (!this.state.failed) return this.props.children
    return <main className="fatal-error"><div><AlertTriangle size={28}/><span className="eyebrow">Algo saiu do caminho</span><h1>Não conseguimos abrir esta tela.</h1><p>Seus dados não foram apagados. Recarregue a aplicação; se o problema continuar, tente entrar novamente.</p><button className="primary-button" onClick={()=>window.location.reload()}><RotateCcw size={16}/> Recarregar</button></div></main>
  }
}
